<template>
  <div>
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
        <h4>Loading...</h4>
    </div>
        <form>
          <div class="p-grid">
            <div class="p-col">
              <Button class="p-button p-component p-button-success addNewBtn width-auto btn-btm-0"  @click.prevent="openAddDialog" icon="pi pi-plus" label="NEW" />
            </div>
          </div>
          <Dialogs  header="Supplier Account"  :visible.sync="addDisplayBasic" :style="{width: '50vw'}"
          :modal="true" :closable=false :contentStyle="{'overflow': 'auto'}">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                <label for="name" >Name<span style="color:red">*</span></label>
                <InputText id="name" v-model.trim="name" />
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="shortName" >Short Name</label>
                <InputText v-model.trim="shortName" id="shortName"/>
              </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="contactPerson" >Contact Person</label>
              <InputText v-model.trim="contactPerson" id="contactPerson"/>
            </div>
              <div class="p-field p-col-12 p-md-6">
                  <label for="tel" >Tel-phone</label>
                  <InputText @keypress="isNumber($event)" v-model.trim="telcontact" id="tel" />
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="contactNum" >Contact Number</label>
                <InputText @keypress="isNumber($event)" v-model="contactNumber" id="contactNum"/>
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="sec">Secondary Contact</label>
                <InputMask mask="(999) 999-9999" v-model.trim="secondaryContact" id="sec"/>
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="email" >Email</label>
                <InputText v-model.trim="email" id="email" />
              </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="address" >Address</label>
              <InputText v-model.trim="address" id="address"/>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="openingBalance" >Opening Balance</label>
              <InputText @keypress="isNumber($event)" v-model.number="openingBalance" id="openingBalance" />
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="accountType">Dr/Cr Type</label>
              <select class="selectBox" v-model="openingDrCr">
                <option selected disabled value="">Select Dr/Cr</option>
                <option  v-for="(drcr,ind) in dr_crList" :key="ind">{{drcr.openingDrCr}}</option>
              </select>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="panNo" >Pan/Vat No</label>
              <InputText @keypress="isNumber($event)" v-model.number="panNo" id="panNo"/>
            </div>
             <div class="p-field p-col-12 p-md-6">
                <label for="status1" >Status</label>
                <div class="p-field p-col-12 p-md-6 radiobox">
                  <div class="radiobox-itm">
                    <RadioButton id="status1" name="ACTIVE" value="ACTIVE" v-model="status" />
                    <label for="status1">Active</label>
                  </div>
                  <div class="radiobox-itm">
                    <RadioButton id="status2" name="INACTIVE" value="INACTIVE" v-model="status" />
                    <label for="status2">Inactive</label>
                  </div>
                </div>
              </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="creditDays" >Credit Days</label>
              <InputText v-model.trim="creditDays" id="creditDays"/>
            </div>
           <div class="p-field p-col-12 p-md-6">
            <label for="creditLimit" >Credit Limit</label>
            <InputText v-model.trim="creditLimit" id="creditLimit"
            />
          </div>
      </div>
      <template #footer>
        <Button class="p-button-raised" @click.prevent="addAccountMaster" :label="editing?'Update':'Add'"/>
        <Button class="p-button-raised p-button-info" label="Add & New" @click.prevent="addAndNewAccountMaster" v-if="!editing"/>
        <Button  @click.prevent="addCancel" class="p-button-raised p-button-danger" label="Cancel"/>
      </template>
      </Dialogs>
    </form>
  </div>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import RadioButton from 'primevue/radiobutton'
import Dialogs from 'primevue/dialog'
import Toast from 'primevue/toast'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
export default {
  name: 'supplier',
  data() {
    return {
      name: '',
      contactNumber: '',
      address: '',
      shortName: '',
      telcontact: '',
      secondaryContact: '',
      email: '',
      contactPerson: '',
      dateOfBirth: '',
      openingBalance: 0,
      dialogShow: false,
      addDisplayBasic: false,
      addDialog: false,
      editing: false,
      panNo: '',
      status: 'ACTIVE',
      id: '',
      accountDetailId: '',
      accountId: '',
      openingDrCr: 'Cr',
      dr_crList: [
        {'openingDrCr': 'Dr'},
        {'openingDrCr': 'Cr'}
      ],
      loading: false,
      columnList: '',
      filters: {},
      creditDays: 0,
      creditLimit: 0
    }
  },
  methods: {
    async addAccountMaster() {
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Account Name cannot be empty!', life: 10000})
        return
      }
      let resp = ''
      let accountMaster = {
        name: this.name,
        shortName: this.shortName,
        primaryContactNumber: this.contactNumber,
        secondaryContactNumber: this.secondaryContact,
        telContact: this.telcontact,
        address: this.address,
        email: this.email,
        contactName: this.contactPerson,
        dateOfBirthEnglish: this.dateOfBirth,
        accountDetailId: this.accountDetailId,
        id: this.id,
        panNo: this.panNo,
        openingBalance: this.openingBalance,
        openingDrCr: this.openingDrCr,
        status: this.status,
        creditDays: this.creditDays,
        creditLimit: this.creditLimit
      }
      if (!this.editing) {
        this.loading = !this.loading
        resp = await this.$store.dispatch('createSupplierAccount', accountMaster)
        this.$emit('set_supplier_master', resp.data.data)
        this.loading = false
      } else {
        this.loading = !this.loading
        resp = await this.$store.dispatch('updateSupplierAccount', accountMaster)
        this.loading = false
      }
      this.responseMessage(resp)
      this.closeAddDialog()
    },
    async addAndNewAccountMaster() {
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Account Name cannot be empty!', life: 10000})
        return
      }
      let resp = ''
      let accountMaster = {
        name: this.name,
        shortName: this.shortName,
        primaryContactNumber: this.contactNumber,
        secondaryContactNumber: this.secondaryContact,
        telContact: this.telcontact,
        address: this.address,
        email: this.email,
        contactName: this.contactPerson,
        dateOfBirthEnglish: this.dateOfBirth,
        accountDetailId: this.accountDetailId,
        panNo: this.panNo,
        openingBalance: this.openingBalance,
        openingDrCr: this.openingDrCr,
        status: this.status,
        creditDays: this.creditDays,
        creditLimit: this.creditLimit
      }
      this.loading = !this.loading
      resp = await this.$store.dispatch('createSupplierAccount', accountMaster)
      this.loading = false
      this.responseMessage(resp)
    },
    responseMessage(resp) {
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.reset()
        this.editing = false
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
    },
    editSupplier(data) {
      this.addDialog = true
      this.id = data.id
      this.editing = true
      this.name = data.name
      this.status = data.status
      this.shortName = data.shortName
      this.address = data.address
      this.telcontact = data.telContact
      this.dateOfBirth = data.dateOfBirthEnglish
      this.contactNumber = data.primaryContactNumber
      this.secondaryContact = data.secondaryContactNumber
      this.email = data.email
      this.panNo = data.panNo
      this.contactPerson = data.contactName
      this.accountDetailId = data.accountDetailId
      this.openingBalance = data.openingBalance
      this.openingDrCr = data.openingDrCr
      this.creditDays = data.creditDays
      this.creditLimit = data.creditLimit
      // if (this.openingBalance > 0) {
      //   this.openingDrCr = 'Cr'
      // } else {
      //   this.openingDrCr = 'Dr'
      // }
      if (this.status === undefined) {
        this.status = 'INACTIVE'
      }
      this.openAddDialog()
    },
    reset() {
      this.name = ''
      this.email = ''
      this.address = ''
      this.contactNumber = ''
      this.shortName = ''
      this.telcontact = ''
      this.openingBalance = ''
      this.openingDrCr = 'Cr'
      this.secondaryContact = ''
      this.contactPerson = ''
      this.panNo = ''
      this.creditDays = 0
      this.creditLimit = 0
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    openAddDialog() {
      this.addDisplayBasic = true
    },
    closeAddDialog() {
      this.addDisplayBasic = false
    },
    addCancel() {
      this.reset()
      this.closeAddDialog()
    }
  },
  components: {
    Dropdown,
    RadioButton,
    Dialogs,
    Toast,
    Button,
    InputText,
    InputMask
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// SupplierAccountDialog.vue?06cf9261